import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Topbar from "../scenes/global/Topbar";
import Sidebar from "../scenes/global/Sidebar";

import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "../theme";


import AdminDashboard from './admindashboard';

import Mypayment from './innerpage/payment/payment-withdraw'
import Mypaymenthistroy from "./innerpage/payment/payment-histroy";
import Myfund from "./innerpage/fund/fund-req-details";
import Basicpin from "./innerpage/fund/basic";
import Premiumpin from "./innerpage/fund/premium";
import Basichistroy from "./innerpage/fund/basichistroy";
import Premiumhistroy from "./innerpage/fund/premiumhistroy";
import Adminchargesmain from "./innerpage/admincharges/admin-charges-main";
import BasicAdminCharges from "./innerpage/admincharges/BasicAdminCharges";
import PremiumAdminCharges from "./innerpage/admincharges/PremiumAdminCharges";
import Gstmain from "./innerpage/gst/gst-main";
import ViewComplaint from "./innerpage/complaints/view-complaint";
import CashBack from "./innerpage/cashback/CashbackDetails";
import WeeklyPerformance from "./innerpage/bonus/performance-bonus";
import AutoClub from "./innerpage/autoclub/AutoClub";
import Retopup from "./innerpage/retopup/Retopup";
import Repurchases from "./innerpage/repurchase/Repurchase";
import Vendorincome from "./innerpage/vendorincome/Vendorincome";
import Awardsrewards from "./innerpage/awards&rewards/AwardsandRewards";
import ProductPackage from "./innerpage/disproduct/productpackage";
import Savedamt from "./innerpage/saveamt/saveamt";
import Activeproduct from "./innerpage/actproduct/actproduct";
import Activatebasicproduct from "./innerpage/actproduct/basicinner";
import Banner from "./innerpage/ecommerce/banner";
import AdditionalCategory from "./innerpage/ecommerce/additional";

import Promotionproduct from "./innerpage/ecommerce/promotionproduct";
import Quickdeals from "./innerpage/ecommerce/quickdeals";
import Onlinestore from "./innerpage/ecommerce/onlinestore";
import Category from "./innerpage/ecommerce/category";
import Facebook from "./innerpage/socialmedia/fb";
import Canonical from "./innerpage/canonical/canonical";
import Profile from "./Outerinnerpage/Profile";
import Userprofile from "./Outerinnerpage/Userpanel/Userprofile";
import FreeActivation from "./Outerinnerpage/Userpanel/FreeActivation";
import Freeregistration from "./Outerinnerpage/Userpanel/Freeregistration";
import Autoincome from "./Outerinnerpage/Editincome/Autoincome";
import Cashbankincome from "./Outerinnerpage/Editincome/Cashbankincome";
import Clubincome from "./Outerinnerpage/Editincome/Clubincome";
import Editincome from "./Outerinnerpage/Editincome/Editincome";
import Kyc from "./Outerinnerpage/KYC/Kyc";
import Processincome from "./Outerinnerpage/Processincome.js/Processincome";
import Awardandreword from "./Outerinnerpage/Awardandreword/Awardandreword";
import Bankaccountdetails from "./Outerinnerpage/Bankaccountdetails/Bankaccountdetails";
import Ewallet from "./Outerinnerpage/Wallet/Ewallet";
import TotalEarningsales from "./Outerinnerpage/SalesReport/ToralEarningsales";
import Daily from "./Outerinnerpage/SalesReport/Daily";
import Weekly from "./Outerinnerpage/SalesReport/Weekly";
import Monthly from "./Outerinnerpage/SalesReport/Monthly";
import Yearly from "./Outerinnerpage/SalesReport/Yearly";
import PinRequest from "./Outerinnerpage/PINs/PinRequest";
import PinStatus from "./Outerinnerpage/PINs/PinStatus";
import PinTransfer from "./Outerinnerpage/PINs/PinTransfer";
import Genrateinvoice from "./Outerinnerpage/Invoice/Genrateinvoice";
import Viewinvoice from "./Outerinnerpage/Invoice/Viewinvoice";
import Formsixteen from "./Outerinnerpage/Formsixteen/Formsixteen";
import FreePingenration from "./Outerinnerpage/PINs/FreePingenration";
import Update from "./Outerinnerpage/Update";
import Editpurchaseincome from "./Outerinnerpage/Editpurchaseincome";
import Editincomeadmin from "./Outerinnerpage/Editincomeadmin";
import DetailsClick from "./innerpage/actproduct/DetailsClick";
import Reparchaseclick from "./innerpage/admincharges/Reparchaseclick";
import VendorAdminclick from "./innerpage/admincharges/VendorAdminclick";
import BankDetails from "./Outerinnerpage/Bankaccountdetails/BankDetails";
import Bankvendor from "./Outerinnerpage/Bankaccountdetails/Bankvendor";
import User from "./Outerinnerpage/KYC/User";
import Vendor from "./Outerinnerpage/KYC/Vendor";
import ViewProfile from "../scenes/ViewProfile";

import Notification from "./innerpage/Notification/Notification";
import Testimonial from "./innerpage/Testimonial/Testimonial";
import ImageModal from "./Outerinnerpage/KYC/ImageModal";
import ShoppingWallet from "./Outerinnerpage/Userpanel/ShoppingWallet";
import Vendordeposit from "./innerpage/Vendordeposit/Vendordeposit";
import Vendorwithdraw from "./innerpage/Vendordeposit/Vendorwithdraw";



const  Adminapp =() =>{
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);

  const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <Sidebar isSidebar={isSidebar} isSidebarCollapsed={isSidebarCollapsed} />
          <main className="content">
            <Topbar setIsSidebar={setIsSidebar} isSidebarCollapsed={isSidebarCollapsed} 
              toggleSidebar={toggleSidebar} style={{width:"100%"}}
            />
            <div className="page-top">

            <Routes>
              <Route exact path="/" element={<AdminDashboard/>} />

              <Route exact path="/mypayment" element={<Mypayment />} />

              <Route exact path="/paymenthistroy" element={<Mypaymenthistroy />} />

              <Route exact path="/myfunddetails" element={<Myfund />} />

              <Route exact path="/basicpin" element={<Basicpin />} />

              <Route exact path="/premiumpin" element={<Premiumpin />} />
              <Route exact path="/basichistroy" element={<Basichistroy />} />
              <Route exact path="/priemumhistroy" element={<Premiumhistroy />} />
              <Route exact path="/adminmain" element={<Adminchargesmain />} />
              <Route exact path="/BasicAdminCharges" element={<BasicAdminCharges />} />
              <Route exact path="/PremiumAdminCharges" element={<PremiumAdminCharges />} />
              <Route exact path="/gstmain" element={<Gstmain />} />
              <Route exact path="/viewcomplaint" element={<ViewComplaint />} />
              <Route exact path="/Vendorwithdraw" element={<Vendorwithdraw />} />
              

              <Route exact path="/Notification" element={<Notification />} />
              <Route exact path="/Testimonial" element={<Testimonial />} />

              <Route exact path="/cashback" element={<CashBack />} />
              <Route exact path="/weeklyperformance" element={<WeeklyPerformance />}/>
              <Route exact path="/autoclub" element={<AutoClub />} />

              <Route exact path="/retopup" element={<Retopup />} />

              <Route exact path="/repurchase" element={<Repurchases />} />
              <Route exact path="/vendorincome" element={<Vendorincome />} />
              <Route exact path="/awardsrewards" element={<Awardsrewards />} />
              <Route exact path="/distributeproducts" element={<ProductPackage />}/>
              <Route exact path="/savedamount" element={<Savedamt />} />

              <Route exact path="/activationproducts" element={<Activeproduct />} />
              <Route exact path="/basicproductinner" element={<Activatebasicproduct />} />

              <Route exact path="/BankDetails" element={<BankDetails />} />
              <Route exact path="/Bankvendor" element={<Bankvendor />} />

              {/* ===================================ecommerce============================ */}

              <Route exact path="/Banner" element={<Banner/>}/>
              <Route exact path="/AdditionalCategory" element={<AdditionalCategory/>}/>
              <Route exact path="/Category" element={<Category/>}/>
              <Route exact path="/PromotionalProduct" element={<Promotionproduct/>}/>
              <Route exact path="/QuickDeals" element={<Quickdeals/>}/>
              <Route exact path="/OnlineStore" element={<Onlinestore/>}/>
              <Route exact path="Vendor" element={<Vendor />} />
              <Route exact path="User" element={<User />} />
              <Route exact path="ViewProfile" element={<ViewProfile />} />
              <Route exact path="ShoppingWallet" element={<ShoppingWallet />} />



              {/* ==========================social media======================= */}

              <Route exact path="/Facebook" element={<Facebook/>}/>
              <Route exact path="/Canonical" element={<Canonical/>}/>


              {/* ============================outer innerpage======================== */}

              <Route exact path="/Profile" element={<Profile/>}/>

              <Route exact path="/Userprofile" element={<Userprofile/>}/>
              <Route exact path="/FreeActivation" element={<FreeActivation/>}/>
              <Route exact path="/Freeregistration" element={<Freeregistration/>}/>

              <Route exact path="/Autoincome" element={<Autoincome/>}/>
              <Route exact path="/Cashbankincome" element={<Cashbankincome/>}/>
              <Route exact path="/Clubincome" element={<Clubincome/>}/>
              <Route exact path="/Editincome" element={<Editincome/>}/>

              <Route exact path="/Vendordeposit" element={<Vendordeposit/>}/>

              <Route exact path="/kyc" element={<Kyc/>}/>
              <Route exact path="/Processincome" element={<Processincome/>}/>
              <Route exact path="/Awardandreword" element={<Awardandreword/>}/>
              <Route exact path="/Bankaccountdetails" element={<Bankaccountdetails/>}/>
              <Route exact path="/Ewallet" element={<Ewallet/>}/>
              <Route exact path="/weeklyperformance" element={<WeeklyPerformance/>}/>
              <Route exact path="/Daily" element={<Daily/>}/>
              <Route exact path="/Weekly" element={<Weekly/>}/>
              <Route exact path="/Monthly" element={<Monthly/>}/>
              <Route exact path="/Yearly" element={<Yearly/>}/>
              <Route exact path="/TotalEarningsales" element={<TotalEarningsales/>}/>
              <Route exact path="/pin-request" element={<PinRequest/>}/>
              <Route exact path="/FreePingenration" element={<FreePingenration/>}/>
              <Route exact path="/PinStatus" element={<PinStatus/>}/>
              <Route exact path="/PinTransfer" element={<PinTransfer/>}/>
              <Route exact path="/Genrateinvoice" element={<Genrateinvoice/>}/>
              <Route exact path="/Viewinvoice" element={<Viewinvoice/>}/>
              <Route exact path="/Formsixteen" element={<Formsixteen/>}/>
              <Route exact path="/Update" element={<Update/>}/>
              <Route exact path="/Editpurchaseincome" element={<Editpurchaseincome/>}/>
              <Route exact path="/Editincomeadmin" element={<Editincomeadmin/>}/>
              <Route exact path="/DetailsClick" element={<DetailsClick/>}/>
              <Route exact path="/Reparchaseclick" element={<Reparchaseclick/>}/>
              <Route exact path="/VendorAdminclick" element={<VendorAdminclick/>}/>
              <Route exact path="/ImageModal" element={<ImageModal/>}/>

              </Routes>
            </div>
           
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default Adminapp;
